import React  from 'react'
import mathHelper from '../Helpers/mathHelper';


class RateMicroGraph extends React.Component 
{
    static defaultProps=
    {
        numbers: [23,42,56,21,70,],
        colors: ["red", "orange", "green", "blue", "gray","gainsboro", "brown","darkblue","darkgreen","darkred" ],
        names:[],
        showNumbers: false,
    }

    constructor(props) 
    {
        super(props);
        this.state = {
        };
    }

    componentDidMount() 
    {
        
    }

    render()
    {
        //if(!mathHelper.ContainsNegative(this.props.numbers)) return null;

        let sum = mathHelper.Sum(this.props.numbers);
        if (sum <= 0) return null;
        let divs=[];
        this.props.numbers.forEach((n, index) => {
            if(parseInt(n)>0)
            {
                let percentage=mathHelper.PercentageText(n,sum);
                divs.push(
                    <div 
                        className="h-100 text-center " 
                        style={{width:percentage, backgroundColor:this.props.colors[index]}} 
                        key={"r"+this.props.colors[index]}
                        data-tip={this.props.names.length>index?this.props.names[index]:""} 
                    >
                        {this.props.showNumbers?n:<>&nbsp;</>}
                    </div>
                );
            }
        });
        return (
            <div className="d-flex m-1">

                {divs}                
            </div>
        );
    }
}



export default RateMicroGraph;
